module.exports = __webpack_public_path__ + "img/library-night.3dc105ec.webp";